import React from "react";
import Navbar from "../Components/Navbar";
import TeenCampPage1 from "../Components/TeenCampPage1";
import TeenCampPage2 from "../Components/TeenCampPage2";
import TeenCampPage3 from "../Components/TeenCampPage3";
import Footer from '../Components/Footer';
import '../Styles/CampsTeens.scss';
import {Helmet} from "react-helmet";

function CampsTeens() {
   return (
      <div>
         <Helmet>
            <title>Youth Camp - Camp Connect</title>
         </Helmet>
         <div className = "teenNavbar">
         <Navbar/>
         </div>
         <TeenCampPage1/>
         <TeenCampPage2/>
         <TeenCampPage3/>
         <Footer/>
      </div>
   )
};

export default CampsTeens;
